const mobileColumns = [
  {
    title: 'A/C No.',
    dataIndex: 'accountNo',
    width: '40%',
  },
  {
    title: 'Balance',
    dataIndex: 'balance',
    width: '35%',
    render: (text) => (
      <span className="font-bold">{text || '00'}</span>
    ),
  },
  {
    title: 'A/C Type',
    dataIndex: 'acType',
    width: '35%',
    render: (text) => (
      <span className="">{text || 'N/A'}</span>
    ),
  },
  {
    title: 'Leverage',
    dataIndex: 'leverage',
    width: '25%',
    render: (text) => (
      <span >
        {text || 'N/A'}
      </span>
    ),
  },
  {
    title: 'Created At',
    dataIndex: 'createdAt',
  },
];

export default mobileColumns;